export const projectRoute = 'project/:projectId'

export const peopleRoute = 'people'
export const personRoute = 'person/:userId'

export const monitoringSystemsRoute = '/monitoring-systems'
export const createNewMonitoringSystemRoute = '/create-monitoring-systems'
export const monitoringSystemRoute = '/monitoring-system/:monitoringSystemId'

export const workspaceRoute = 'workspace/'
export const createWorkspaceRoute = 'create-workspace'
export const allWorkspaces = 'admin'

export const airImpact = 'airimpact'
export const createSuperAdminRoute = 'create-administrator'

export const eventsRoute = '/events'
export const eventRoute = '/event/:eventId'
export const createEventRoute = '/create-event'
export const createMilestoneRoute = 'milestones/create/:type/*'

export const milestoneRoute = 'milestones/:milestoneId/*'
export const milestoneUpdateRoute = 'milestones/:milestoneId/create-update'
export const milestoneReleaseRoute = 'milestones/:milestoneId/release'

export const certificationAgencyProjects = 'certification-agency-projects'
export const certificationAgencyApprovals = 'certification-agency-approvals'
export const certificationAgencyReview = 'certification-agency-projects/:projectId/*'

export const accountSettings = 'account-settings'
